<script>
	export let title;
	export let titleShort;
	export let id;
	export let year;
	export let type;
	export let description;
	export let links;
	export let favorite;

	export let tags;

	export let githubStars;
	export let venue;
	export let honors;
	export let workshop;

	import { Button, Icon, Tag } from "svelma";
	import { slide } from "svelte/transition";

	import { numberWithCommas } from "../utils";

	if (!titleShort) titleShort = title;

	const bgUrl = `assets/projects/${id}/titleimg.png`;

	const buttonTypes = [
		{ title: "Website", icon: "globe-americas", pack: "fas" },
		{ title: "Abstract", icon: "file-alt", pack: "fas" },
		{ title: "Paper", icon: "file-alt", pack: "fas" },
		{ title: "Github", icon: "github", pack: "fab" },
		{ title: "Code", icon: "file-code", pack: "fas" },
		{ title: "Devpost", icon: "flag", pack: "fas" },
	];

	let expanded = false;
	const rickroll = `
		<figure>
			<iframe width="500" height="281" src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1&start=0&controls=0&loop=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			<figcaption> Gotcha :^ )</figcaption>
		</figure>`;
	const gogoGadgetRick =
		id == "website" && window.location.href.includes("?lol");
</script>

<div class="card">
	<div class="card-image" on:click={() => (expanded = !expanded)}>
		<figure class="image">
			<img src={bgUrl} alt={title} />
			<span class="titletext">{titleShort}</span>
			{#if githubStars}
				<span class="titlestars">
					<Icon pack="fas" icon="star" size="is-small" />
					{numberWithCommas(githubStars)}
				</span>
			{/if}
		</figure>
	</div>
	{#if expanded}
		<div transition:slide>
			<div class="card-content">
				<div class="media">
					<div class="media-content">
						<p class="title is-4">{title}</p>
						{#if venue}
							<p class="subtitle is-6">
								{venue}
								{year}
								{#if workshop} Workshop ({workshop}) {/if}
								{#if honors} <em>{honors}</em> {/if}
							</p>
						{/if}
						<p>
							{#each buttonTypes as buttonType, i}
								{#if links[buttonType.title]}
									<a
										href={links[buttonType.title]}
										style="margin-right:5px"
									>
										<Button>
											<Icon
												pack={buttonType.pack}
												icon={buttonType.icon}
											/> &nbsp; {buttonType.title}
										</Button></a
									>
								{/if}
							{/each}
						</p>
					</div>
				</div>

				<div class="content">
					{#if gogoGadgetRick}
						{@html rickroll}
					{:else}
						{@html description}
					{/if}
					<br />
					<div style="text-align:right">
						{#each tags as tag}
							<Tag>{tag}</Tag> &nbsp;
						{/each}
					</div>
				</div>
			</div>
			<!-- <footer class="card-footer">
				<a href="#" class="card-footer-item">Save</a>
			</footer> -->
		</div>
	{/if}
</div>

<style>
	figure > img {
		height: 42px;
		object-fit: cover;
		object-position: center;
	}
	figure > span.titletext {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		color: azure;
		text-shadow: 1px 2px 2px rgba(0, 0, 0, 0.6);

		width: 100%;
		height: 100%;

		text-align: center;
		vertical-align: center;

		font-size: 20pt;
		font-style: normal;
		text-decoration: none;

		user-select: none;

		border-radius: 4px;

		background-image: linear-gradient(
			rgba(0, 0, 0, 0.1),
			rgba(0, 0, 0, 0.5)
		);

		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	figure > span.titlestars {
		position: absolute;
		top: 0px;
		right: 8px;
		vertical-align: top;
		color: azure;
		font-weight: 500;
		font-size: 12pt;
		text-shadow: 1px 2px 2px rgba(0, 0, 0, 0.6);
	}

	figure > span.titletext:hover {
		background-image: linear-gradient(
				rgba(255, 255, 255, 0.2),
				rgba(255, 255, 255, 0.2)
			),
			linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7));
	}

	figure > span.titletext:active {
		background-image: linear-gradient(
			rgba(0, 0, 0, 0.7),
			rgba(0, 0, 0, 0.3)
		);
	}

	figure > span.titletext:hover:active {
		background-image: linear-gradient(
				rgba(255, 255, 255, 0.2),
				rgba(255, 255, 255, 0.2)
			),
			linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3));
	}
</style>
